import axios from 'axios'
import ajax from '@/lib/ajax'

// 已使用 bucket dir fileType 记录
// bucket chinapsp-yw ; dir deposit/ ; filetype 1 ; 保证金上传附件

let fileUtil = {
  async downloadInit(userId, fileType, bucket, dir) {
    // let rep = await axios.get(`${webUrl}/AliOSS/GetSign?dir=test3/`)
    if (!userId || !fileType || !bucket) {
      console.error('缺失参数')
      return
    }
    let rep = await ajax.get('/api/services/app/AbpAliOss/GetSign', {
      params: {
        dir: dir,
        bucket: bucket
      }
    })
    let obj = rep.data.result
    let extradata = {
      'key': obj['dir'], // 未加后缀
      'policy': obj['policy'],
      'OSSAccessKeyId': obj['accessid'],
      'success_action_status': '200', //让服务端返回200,不然，默认会返回204calculate_object_name(filename)
      'callback': obj['callback'],
      'signature': obj['signature'],
      'x:objectid': "",
      'x:userid': userId, // 用户id
      'x:filetype': fileType,
      'x:objectidtype': '',
      'x:displayname': "", // 文件名称
    }
    let action = obj['host']
    return {
      extradata, // 上传附带基本参数
      action, // 上传地址
    }
  },
  // 随机后缀名
  random_string(len = 32) {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ+abcdefghijklmnopqrstuvwxyz-012345678*';
    let maxPos = chars.length;
    let pwd = '';
    for (var i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  // 获取后缀
  get_suffix(filename) {
    let pos = filename.lastIndexOf('.')
    let suffix = ''
    if (pos != -1) {
      suffix = filename.substring(pos)
    }
    return suffix;
  },
  async downLoad(fileId) {
    let rep = await ajax.get('/api/services/app/AbpAliOss/GetDownUrl', {
      params: {
        id: fileId
      }
    })
    return rep.data.result
  },
  async downLoadBlob(fileId) {
    let rep = await ajax.get('/api/services/app/AbpAliOss/GetDownUrl', { 
      params: {
        id: fileId
      }
    })
    let fileRep = await axios.get(rep.data.result, { responseType: 'blob' })
    let blob = new Blob([fileRep.data])
    let fileUrl = window.URL.createObjectURL(blob)
    return fileUrl
  }
}

export { fileUtil }
